import { RadioGroup } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/outline";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { database } from "../../database/firebase";
import useRoomId from "../../hooks/DatabseCollection/useRoomId";

const plans = [
  {
    name: "Public",
  },
  {
    name: "Private",
  },
  {
    name: "Protected",
  },
];

const UpdateRoom = () => {
  const { roomId } = useParams();
  const { roomDetail, loading } = useRoomId(roomId);
  const [name, setRoomName] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);

  const [selectedTab, setSelectedTab] = useState(plans[0]);

  const updateRoom = async () => {
    try {
      setUpdateLoading(true);
      const roomRef = doc(database, "userRooms", roomId);

      await updateDoc(roomRef, {
        roomName: name ? name : roomDetail.roomName,
        privacyMode: selectedTab.name,
        timestamp: serverTimestamp(),
      });
      setUpdateLoading(false);
      setRoomName("");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className={`px-3 py-4 w-[50%]`}>
      {loading ? (
        <div className="flex justify-center">
          <ClipLoader color="black" loading={loading} size={70} />
        </div>
      ) : (
        <>
          <h1 className="py-3 font-semibold">Update Room Details</h1>
          <div>
            <input
              value={name}
              onChange={(e) => setRoomName(e.target.value)}
              type="text"
              placeholder={roomDetail.roomName}
              className="w-full border border-indigo-500 shadow focus:outline-none py-2 px-3 rounded-md"
            />
          </div>
          <div className="w-full mt-3">
            <h1 className="pl-3 py-3">Mode</h1>
            <RadioGroup value={selectedTab} onChange={setSelectedTab}>
              <RadioGroup.Label className="sr-only">
                Privacy Mode.
              </RadioGroup.Label>
              <div className="sm:grid sm:grid-cols-3 sm:gap-3 space-y-5 sm:space-y-0">
                {plans.map((plan, index) => (
                  <RadioGroup.Option
                    key={index}
                    value={plan}
                    className={({ active, checked }) =>
                      `${active ? "bg-gray-100" : " ring-1 border-gray-400"}
                  ${
                    checked ? "bg-sky-900 bg-opacity-75 text-black" : "bg-white"
                  }
                    relative rounded-lg shadow-md px-5 py-4 cursor-pointer flex focus:outline-none`
                    }
                  >
                    {({ active, checked }) => (
                      <>
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center">
                            {checked && (
                              <div className="flex-shrink-0 text-indigo-500 px-2 py-1 rounded-full">
                                <CheckIcon className="w-6 h-6" />
                              </div>
                            )}
                            <div className="text-sm">
                              <RadioGroup.Label
                                as="p"
                                className={`font-medium  ${
                                  checked ? "text-indigo-500" : "text-gray-900"
                                }`}
                              >
                                {plan.name}
                              </RadioGroup.Label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
          </div>
          <div className="mt-10">
            <button
              onClick={updateRoom}
              className="bg-green-600 rounded-md text-white shadow px-4 py-2"
            >
              {updateLoading ? (
                <ClipLoader color="white" loading={loading} size={25} />
              ) : (
                "Update"
              )}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UpdateRoom;
